import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme/theme";
import { API_BASE_URL } from "./config";

axios.defaults.baseURL = API_BASE_URL;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);
